import React from 'react';

export interface SwitchProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: React.ReactNode;
  srLabel?: string;
  disabled?: boolean;
  className?: string;
}

const Switch: React.FC<SwitchProps> = ({
  id,
  checked,
  onChange,
  label,
  srLabel,
  disabled = false,
  className = '',
}) => {
  const button = (
    <button
      id={id}
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={srLabel}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex h-6 w-10 items-center rounded-full transition-colors duration-[var(--motion-duration-fast)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pt-gold focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed ${
        checked ? 'bg-pt-forest' : 'bg-pt-sage'
      } ${className}`.trim()}
    >
      <span
        className={`inline-block h-4 w-4 transform rounded-full bg-pt-cream transition-transform duration-[var(--motion-duration-fast)] ${
          checked ? 'translate-x-5' : 'translate-x-1'
        }`}
        aria-hidden
      />
    </button>
  );
  if (!label) return button;
  return (
    <label
      htmlFor={id}
      className="inline-flex items-center gap-2 cursor-pointer select-none text-sm text-pt-forest"
    >
      {button}
      <span>{label}</span>
    </label>
  );
};

export default Switch;
